import _ from "lodash";
import { EmbeddableAgentData } from "../../services/interfaces";
import { LwTemplateData } from "../../components/lw-template/interfaces";
import { MoModel, MoModelConfig } from "ui-common";

export class AppStudioInitiator extends MoModel {
  public defaultGroupName: string = 'main';
  public urlQueryParam: string;
  public currentQueryId: string;

  templateData: LwTemplateData;

  constructor(data: EmbeddableAgentData = { stores: {} }, config?: MoModelConfig) {
    super(data, config);

    this.bootstrapTemplate();
  }

  async bootstrapTemplate() {
    const templateElements = document.body.querySelectorAll('lw-template');

    _.each(templateElements, async(element: any) => {
      const templateId = element.getAttribute('id');

      element.data = { id: templateId };
    });
  }
}